<div class="wrapper">
  <div class="sidebar">
    <ov-suite-sidebar #sidebar [projectName]="projectName" [routes]="routes"></ov-suite-sidebar>
  </div>
  <div class="main-panel">
    <ov-suite-navbar [routes]="routes"></ov-suite-navbar>
    <router-outlet></router-outlet>
  </div>
</div>
